import { AtelierDetailTourItem } from '../model/atelier-detail-tour-item';
import { Directive, EventEmitter, Input, Output } from '@angular/core';
import { BoardTypeChoices } from '../../../../model/product/board/board-part';

@Directive()
export abstract class AbstractAtelierView {
  @Input()
  selectedItemId;

  @Output()
  selectedItemIdEmitter = new EventEmitter<number>();

  readonly typeDisplayMap = {
    BaseProject: { display: 'Plaatsen', color: 'green' },
    Adjustment: { display: 'Aanpassing', color: '#5482c1' },
    SoldRented: { display: 'Sticker', color: 'darkorange' },
  };

  BOARD_TYPE_CHOICES = BoardTypeChoices;

  toggleSelected(item: AtelierDetailTourItem) {
    if (item.id === this.selectedItemId) {
      this.selectedItemIdEmitter.emit(undefined);
    } else {
      this.selectedItemIdEmitter.emit(item.id);
    }
  }

  itemBackgroundClass(item: AtelierDetailTourItem): string {
    if (item.finished) {
      return 'finished';
    }
    if (
      item.subProject != null &&
      item.subProject.project.firstProduct.printworkRequired &&
      !item.subProject.project.firstProduct.printworkRegistered
    ) {
      return 'printwork';
    }

    return '';
  }
}
